/*
 * Description of what this file is for
 *
 * @package  baukasten
 * @author David Hellmann [davidhellmann.com@gmail.com]
 * pageTitle
 */

// import scrollMonitor from 'scrollmonitor';
// import TweenMax from '../../../../node_modules/gsap/TweenMax';
import fitty from 'fitty';
import anime from 'animejs';
import ScrollMagic from '../../../../node_modules/scrollmagic/scrollmagic/uncompressed/ScrollMagic';
// import TimelineMax from '../../../../node_modules/gsap/src/uncompressed/TimelineMax';
// import Power2 from '../../../../node_modules/gsap/src/uncompressed/TweenLite';

const pageTitle = {
    cfg:  {
        name: 'pageTitle',
        controller: '',
        trigger: document.querySelectorAll('.js-pageTitle'),
        tweenObj: {
            targets: '.js-figure .m-figure__image',
            translateX: '5%',
            scale: 1.1,
            elasticity: 0.5,
            autoplay: false,
            easing: 'linear'
        },
        timeline: anime.timeline(),
        scene: '',
        elements: [...document.querySelectorAll('.js-pageTitle__headline')],
        fitties: [],
        fittyOptions: {
            minSize: 12,
            maxSize: 300,
            observeWindow: true,
        }
    },

    initText() {
        this.cfg.fitties = fitty('.js-pageTitle__headline');

        /* this.cfg.elements.forEach((item) => {
            fitty(item, this.cfg.fittyOptions);
        });

        this.resizeText(); */

        this.cfg.fitties.forEach((fit) => {
            fit.fit();
        });

        // this.resizeText();
    },

    getStyle(el, cssprop) {
        if (el.currentStyle) { // IE & Opera
            return el.currentStyle[cssprop];
        } else if (document.defaultView && document.defaultView.getComputedStyle) { // Gecko & WebKit
            return document.defaultView.getComputedStyle(el, '')[cssprop];
        }
    },

    resizeText() {
        this.cfg.fitties.forEach((fit) => {
            fit.unsubscribe();
        });

        this.cfg.fitties = fitty('.js-pageTitle__headline');

        this.cfg.fitties.forEach((fit) => {
            fit.fit();
        });

        // this.cfg.fitties.fitAll();

        /* this.cfg.elements.forEach((item) => {
            const fontSize = 12; // this.getStyle(item, 'fontSize');
            item.setAttribute('style',`line-height:${fontSize}px`);
        }); */
    },

    init() {
        if (this.cfg.trigger.length > 0) {
            this.cfg.timeline
                .add(this.cfg.tweenObj);

            this.cfg.controller = new ScrollMagic.Controller();

            // build scene
            this.cfg.scene = new ScrollMagic.Scene({
                triggerElement: this.cfg.trigger,
                duration: '200%'
            })
                .addTo(this.cfg.controller)
                .on('progress', (event) => {
                    this.cfg.timeline.seek(this.cfg.timeline.duration * event.progress);
                });
        }

        window.addEventListener('load', () => {
            if (this.cfg.elements.length > 0) {
                this.initText();
                // this.resizeText();
            }
        });

        window.addEventListener('resize', () => {
            if (this.cfg.elements.length > 0) {
                this.resizeText();
            }
        });
    }
};

export default pageTitle;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/pageTitle/_script.js